import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    trainingClassCertificationList: {
        requesting: false,
        items: [],
        pagination: {
          current_page: 1,
          per_page: 10,
          total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
  };

export const trainingClassCertificationSlice = createSlice({
  name: 'trainingClassCertification',
  initialState,
  reducers: {

    // class certification
    getTrainingClassCertificationList: (state, action) => {
        state.trainingClassCertificationList.requesting = true;
        state.trainingClassCertificationList.error = null;
        state.trainingClassCertificationList.items = [];
        state.trainingClassCertificationList.success = false;
        state.trainingClassCertificationList.filters = action.payload;
    },
    getTrainingClassCertificationListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.trainingClassCertificationList.requesting = false;        
        state.trainingClassCertificationList.items = data;
        state.trainingClassCertificationList.success = true; 
        state.trainingClassCertificationList.pagination.current_page = current_page;
        state.trainingClassCertificationList.pagination.per_page = per_page;
        state.trainingClassCertificationList.pagination.total = total;
    },
    getTrainingClassCertificationListFail: (state, action) => {        
        state.trainingClassCertificationList.requesting = false;
        state.trainingClassCertificationList.error = action.payload;
    },
  },
})

export const { 
    // class Certicafication
    getTrainingClassCertificationList,
    getTrainingClassCertificationListSuccess,
    getTrainingClassCertificationListFail,

} = trainingClassCertificationSlice.actions;

export default trainingClassCertificationSlice.reducer;
